import React, {useState} from "react";
import CodeFormField from "./CodeFormField";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const UpdateCodeForm = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "Codes", url: "/codes"},
        {content: "Update Code", url: ""}
    ])

    return (
        <>
            <CodeFormField crumbs={crumbs} title={"Update Code"} btnText={"Update"}
             isReadOnly={!hasPermission(["LOGIC-U"])}/>

        </>
    )
}

export default UpdateCodeForm;